import React from "react";
import FilingReportWidget from "./components/FilingReportWidget";
import FilingBreakdownWidget from "./components/FilingBreakdownWidget";
import FilingMapWidget from "./components/FilingMapWidget";
import DailyReportWidget from "./components/DailyReportWidget";
import DailyUploadsWidget from "./components/DailyUploadsWidget";
import { PortalSelector } from "../../components/shared";
import Apps from "./components/AppRow";
import { LabeledInt, ProgressResult } from "../../models";
import { useState } from "react";
import { useEffect } from "react";
import { ReportService } from "../../services/SubmissionService";
import Footer from "../../components/shared/Footer";
import { Stack, useMediaQuery, useTheme } from "@mui/material";

export default function EFiling() {
    const theme = useTheme();
    const isMobile = useMediaQuery("(max-width:1000px)");
    const [existingFilings, setExistingFilings] = useState(
        new ProgressResult()
    );
    const [newFilings, setNewFilings] = useState(new ProgressResult());
    const [dfsFilings, setDfsFilings] = useState(new ProgressResult());
    useEffect(() => {
        ReportService.getExistingToday({ attorneyId: "" }).then(
            (resp) => {
                setExistingFilings(resp);
            },
            (error) => {
                console.log(error);
            }
        );

        ReportService.getNewToday({ attorneyId: "" }).then(
            (resp) => {
                setNewFilings(resp);
            },
            (error) => {
                console.log(error);
            }
        );

        ReportService.getDfsToday({ attorneyId: "" }).then(
            (resp) => {
                setDfsFilings(resp);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">
                                Welcome to your{" "}
                                {localStorage.getItem("tyler")
                                    ? localStorage
                                          .getItem("tyler")
                                          ?.toUpperCase()
                                    : "eFileMadeEasy"}{" "}
                                Portal!
                            </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Dashboards
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        e-Filing
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-3 col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="knob-chart" dir="ltr">
                                        <input
                                            data-plugin="knob"
                                            data-width="70"
                                            data-height="70"
                                            data-fgColor="#18c984"
                                            data-bgColor="#d1f2eb"
                                            value={newFilings.progress ?? 0}
                                            data-max={newFilings.total ?? 0}
                                            data-skin="tron"
                                            data-angleOffset="0"
                                            data-readOnly={true}
                                            data-thickness=".15"
                                        />
                                    </div>
                                    <div className="text-end">
                                        <h3 className="mb-1 mt-0">
                                            {" "}
                                            <span data-plugin="counterup">
                                                {newFilings.total}
                                            </span>{" "}
                                        </h3>
                                        <p className="text-muted mb-0">
                                            New Cases
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="knob-chart" dir="ltr">
                                        <input
                                            data-plugin="knob"
                                            data-width="70"
                                            data-height="70"
                                            data-fgColor="#526dee"
                                            data-bgColor="#d4dbfd"
                                            value={
                                                existingFilings.progress ?? 0
                                            }
                                            data-max={
                                                existingFilings.total ?? 0
                                            }
                                            data-skin="tron"
                                            data-angleOffset="0"
                                            data-readOnly={true}
                                            data-thickness=".15"
                                        />
                                    </div>
                                    <div className="text-end">
                                        <h3 className="mb-1 mt-0">
                                            {" "}
                                            <span data-plugin="counterup">
                                                {existingFilings.total}
                                            </span>{" "}
                                        </h3>
                                        <p className="text-muted mb-0">
                                            Existing Cases
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="knob-chart" dir="ltr">
                                        <input
                                            data-plugin="knob"
                                            data-width="70"
                                            data-height="70"
                                            data-fgColor="#f672a7"
                                            data-bgColor="#fde3ed"
                                            value={dfsFilings.progress ?? 0}
                                            data-max={dfsFilings.total ?? 0}
                                            data-skin="tron"
                                            data-angleOffset="0"
                                            data-readOnly={true}
                                            data-thickness=".15"
                                        />
                                    </div>
                                    <div className="text-end">
                                        <h3 className="mb-1 mt-0">
                                            <span data-plugin="counterup">
                                                {dfsFilings.total}
                                            </span>{" "}
                                        </h3>
                                        <p className="text-muted mb-0">
                                            DFS Submissions
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="knob-chart" dir="ltr">
                                        <input
                                            data-plugin="knob"
                                            data-width="70"
                                            data-height="70"
                                            data-fgColor="#6c757d"
                                            data-bgColor="#e2e3e5"
                                            value={
                                                (existingFilings.progress ??
                                                    0) +
                                                (newFilings.progress ?? 0) +
                                                (dfsFilings.progress ?? 0)
                                            }
                                            data-max={
                                                (existingFilings.total ?? 0) +
                                                (newFilings.total ?? 0) +
                                                (dfsFilings.total ?? 0)
                                            }
                                            data-skin="tron"
                                            data-angleOffset="0"
                                            data-readOnly={true}
                                            data-thickness=".15"
                                        />
                                    </div>
                                    <div className="text-end">
                                        <h3 className="mb-1 mt-0">
                                            <span data-plugin="counterup">
                                                {(existingFilings.total ?? 0) +
                                                    (newFilings.total ?? 0) +
                                                    (dfsFilings.total ?? 0)}
                                            </span>{" "}
                                        </h3>
                                        <p className="text-muted mb-1">
                                            Total Filings
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Stack
                    direction="column"
                    spacing={6}
                    alignItems="center"
                    alignContent="center"
                    width="100%"
                    justifyContent="center"
                    marginBottom={6}
                >
                    <Apps
                        sx={{
                            width: "100%",
                            paddingY: 1,
                            paddingX: 2,
                        }}
                        buttonSpacing={6}
                        iconSpacing={6}
                    />
                    <PortalSelector
                        sx={{
                            width: "100%",
                            height: "10rem",
                            paddingX: 2,
                        }}
                    />
                    <Stack
                        direction={isMobile ? "column" : "row"}
                        spacing={4}
                        alignItems="center"
                        alignContent="center"
                        width="100%"
                        height="100%"
                    >
                        <FilingReportWidget />
                        <DailyUploadsWidget />
                    </Stack>
                    <Stack
                        direction={isMobile ? "column" : "row"}
                        spacing={4}
                        alignItems="center"
                        alignContent="center"
                        width="100%"
                        height="100%"
                    >
                        <FilingBreakdownWidget />
                        <FilingMapWidget />
                    </Stack>
                    <Stack
                        direction="row"
                        alignItems="center"
                        alignContent="center"
                        width="100%"
                        height="100%"
                    >
                        <DailyReportWidget />
                    </Stack>
                </Stack>
            </div>
            <Footer />
        </div>
    );
}
